import React from "react";
import PropTypes from "prop-types";
import AssettypeImage from "../../../../../atoms/responsive-image-with-fallback/assetypeImage";

const StoryElementImage = ({ element, story = {}, imageWidths, imageDefaultWidth, onClick = () => {} }) => {
  return (
    <div className="story-element story-element-image">
      <figure>
        <AssettypeImage
          slug={element["image-s3-key"]}
          metadata={element["metadata"]}
          aspectRatio={null}
          defaultWidth={imageDefaultWidth || 700}
          widths={imageWidths || [400, 700, 800]}
          imgParams={{
            auto: ["format", "compress"]
          }}
          sizes="(max-width: 500px) 400px, (max-width: 768px) 400px, (max-width: 1024px) 700px, 800px"
          alt={element.title || story.headline}
          onClick={onClick}
        />
        <div className="story-element-caption-attribution-wrapper">
          {element.title && (
            <figcaption className="story-element-image-title" dangerouslySetInnerHTML={{ __html: element.title }} />
          )}
          {element["image-attribution"] && (
            <figcaption
              className="story-element-image-attribution"
              dangerouslySetInnerHTML={{ __html: element["image-attribution"] }}
            />
          )}
        </div>
      </figure>
    </div>
  );
};

StoryElementImage.propTypes = {
  story: PropTypes.object,
  element: PropTypes.object,
  imageWidths: PropTypes.string,
  imageDefaultWidth: PropTypes.string,
  onClick: PropTypes.func
};

export default StoryElementImage;
